.container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.divider {
  margin-top: 16px;
  margin-bottom: 16px;
}

.content {
  flex: 1;
  overflow: auto;
}
